import styled from 'styled-components';


export const StyledTitle = styled.div`
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  font-family: Brandon;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #252930;
`;

export const StyledSectionTitle = styled.span`
  font-family: Brandon;
  position: absolute!important; /* Overrides specificity with bit centeredContent */
  top: 24px;
  left: 24px;
  font-style: normal;
  font-weight: thin;
  font-size: 14px;
  line-height: 19px;
  color: #3A4049;
  text-transform: capitalize;
`;
